import { ColorUtils } from "tree2d";
export function ensureColor(v) {
    return ColorUtils.getArgbFromAny(v);
}
export function ensureInt(v) {
    if (typeof v === "number") {
        return v;
    }
    else {
        return parseInt(v) || 0;
    }
}
export function ensureFloat(v) {
    if (typeof v === "number") {
        return v;
    }
    else {
        return parseFloat(v) || 0.0;
    }
}
export function ensureBoolean(v) {
    return v !== "false" && !!v;
}
export function isString(value) {
    return typeof value === "string";
}
export function isNumber(value) {
    return typeof value === "number";
}
export function parseFloatStrict(value) {
    if (/^([-+])?([0-9]+(\.[0-9]+)?|Infinity)$/.test(value))
        return Number(value);
    return NaN;
}
//# sourceMappingURL=TypeUtils.js.map